import { render, staticRenderFns } from "./DeleteOrderConfirmationModal.vue?vue&type=template&id=053bc12f&"
import script from "./DeleteOrderConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./DeleteOrderConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteOrderConfirmationModal.vue?vue&type=style&index=0&id=053bc12f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports